import { Box, ButtonBase, Typography, useTheme } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import {
  customAmount,
  customLineLabel,
} from '../../../utils/checkout/customLine';

interface Props {
  query: string;
  onAdd: () => void;
}

/** Adds what was typed in search as a line that is not in the item library. */
export default function CustomLineRow({ query, onAdd }: Props) {
  const theme = useTheme();
  const isAmount = customAmount(query) !== null;
  return (
    <ButtonBase
      onClick={onAdd}
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 1,
        px: 1,
        py: 0.5,
        borderRadius: '10px',
        textAlign: 'left',
        fontFamily: theme.typography.fontFamily,
        '&:hover': { bgcolor: theme.palette.accent.main },
      }}>
      <Box
        sx={{
          width: 28,
          height: 28,
          flexShrink: 0,
          borderRadius: '8px',
          border: `1px dashed ${theme.palette.divider}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: theme.palette.text.secondary,
        }}>
        <AddRoundedIcon fontSize="small" />
      </Box>
      <Typography variant="body2" noWrap sx={{ flex: 1, minWidth: 0 }}>
        {customLineLabel(query)}
      </Typography>
      {!isAmount && (
        <Typography
          variant="caption"
          color="text.secondary"
          noWrap
          sx={{ flexShrink: 0 }}>
          Set the price in checkout
        </Typography>
      )}
    </ButtonBase>
  );
}
